import { Stack } from "@/core/components/ui/stack";
import { PayrollStatementNotificationsContent } from "@/payroll/pay-breakdown/payroll-statement-notifications/payroll-statement-notifications-page";

// The full statement-emails feature, mounted INLINE (scoped to the current
// period) — the same view the standalone /notifications route renders, minus its
// page chrome. Preview-only tenants receive the same read experience without any
// mutation controls. It uses the same fixed-height envelope as the Grid tab
// so the feature's internal flex-1 table fills the tab and scrolls internally.
//
// The section's provider is mounted by the page rather than here, because the
// header controls it feeds render above this tab.
export const PayBreakdownEmailsTab = () => (
  <Stack
    gap="none"
    align="stretch"
    fullWidth
    className="h-[calc(100dvh-180px)] max-h-[1200px] min-h-[520px] min-w-0"
  >
    <PayrollStatementNotificationsContent embedded />
  </Stack>
);
